const PROFILE_MESSAGES = {
  PROFILE_INVALID_DATA: 'Invalid Data',
  PROFILE_FAILURE: 'Unable to fetch profile data.',
  PROFILE_POST_SUCCESS: 'Updated successfully',
  PROFILE_POST_FAILURE: 'Oops!!! Something, Somewhere, Shomehow went wrong...',
}

export default PROFILE_MESSAGES
